import {LkApi} from 'api/LkApi';
import {GlobalApi} from 'api/globalApi';
import {isDealersLk} from 'lib/isDealersLk';

export type ApiResponseError = {
    message?: string;
};

export const lkApi = new LkApi(isDealersLk() ? 'dealers' : 'retail');
export const globalApi = new GlobalApi();
